// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1rc9t","options":"AnswerScale_options__3ieni","selected":"AnswerScale_selected__RSWMx"};